(() => {
    if (document.documentElement.dataset.collectionHeroNavInit) {
        return;
    }

    document.documentElement.dataset.collectionHeroNavInit = 'true';

    const pendingSelector = '.collection-hero--navigation-link a.is-pending';

    const clearPending = (root = document) => {
        for (const link of root.querySelectorAll(pendingSelector)) {
            link.classList.remove('is-pending');
        }
    };

    document.addEventListener('click', (event) => {
        const link = event.target.closest('.collection-hero--navigation-link a');

        if (!link) {
            return;
        }

        if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
        }

        const nav = link.closest('.collection-hero--navigation');

        if (!nav) {
            return;
        }

        clearPending(nav);
        link.classList.add('is-pending');
    });

    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            clearPending();
        }
    });
})();
